// Create a Map to store the carousel instances
const carouselInstances = new Map()
import Splide from '@splidejs/splide'

/**
 * Create a new Carousel object.
 * @param {String} selector - Element selector.
 * @param {Object} config - Settings object defined when instantiating.
 * @returns {Object} carousel
 */
export default function Carousel(selector, config) {

  /**
   * Carousel settings.
   * - Override these settings via the config parameter.
   */
  const nodeSelectors = {
    carousel: document.querySelector(selector),
  }

  if (!nodeSelectors.carousel) {
    return
  }

  const namespace = nodeSelectors.carousel.getAttribute('js-carousel')
  if (!namespace) {
    window.console.error('Error: carousel does not have a unique namespace.')
    return
  }

  // Check if an instance already exists for the given namespace
  const existingInstance = carouselInstances.get(namespace)
  if (existingInstance) {
    // If it exists, destroy it
    existingInstance.destroy()
    carouselInstances.delete(namespace)
  }

  /**
   * Initiate new Carousel instance with custom settings.
   */
  const carousel = new Splide(nodeSelectors.carousel, {
    arrows: false,
    drag: true,
    flickPower: 200,
    mediaQuery: 'min',
    pagination: false,
    type: 'loop',
    ...config,
  })

  // Store the new instance in the Map
  carouselInstances.set(namespace, carousel)

  // eslint-disable-next-line consistent-return
  return carousel
}
